import objectAssign from 'object-assign';
import moment from 'moment'

import auth, { sessionsAllowed } from '~/services/auth'


export function session( state = { 
	bookmarks: [],
	camps: [],
	history: [],
	interests: [],
	passwordReset: false,
	recommendedCamps: [],
	status: '', 
	subscription: {}, 
	user: {}, 
	fetching: {
		bookmarks: false,
		camps: false,
		credits: false,
		history: false,
		interests: false,
		passwordReset: false,
		recommendedCamps: false,
		subscription: false,
		user: false
	},
	sessionsAllowed: sessionsAllowed()
}, action ) {

	switch (action.type) {

		case 'REQUEST_SESSION':
			return objectAssign({}, state, {
				status: '',
				fetching: Object.assign({}, state.fetching, {
					user: true,
					credits: true
				}), 
			})

		case 'RECEIVE_SESSION':
			if(action.session) {
				if(action.session.jwt) auth.setToken(action.session.jwt)
				var is_expired = action.session === 'expired' || !action.session.expiry || moment(  ).isAfter( moment( action.session.expiry*1000 ) )
				if(is_expired) auth.logout()
			}
			return objectAssign({}, state, {
				user: action.user,
				status: 'ID' in action.user ? (action.user.registered ? 'registered' : 'registering') : 'no_session',
				fetching: Object.assign({}, state.fetching, {
					user: false,
					credits: false
				})
			})

		case 'REQUEST_DELETE_SESSION':
			return objectAssign({}, state, {
				status: 'no_session',
				user: {},
				bookmarks: [],
				camps: [],
				recommendedCamps: [],
				interests: [],
				history: []
			})

		case 'REQUEST_USER_CAMPS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {camps: true})
			})

		case 'RECEIVE_USER_CAMPS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {camps: false}),
				camps: action.camps
			})

		case 'REQUEST_RECOMMENDED_CAMPS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {recommendedCamps: true})
			})

		case 'RECEIVE_RECOMMENDED_CAMPS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {recommendedCamps: false}),
				recommendedCamps: action.camps
			})

		case 'REQUEST_CREDITS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {credits: true})
			})

		case 'RECEIVE_CREDITS':
			var newData = {
				fetching: Object.assign({}, state.fetching, {credits: false})
			}
			if( action.credits || action.credits === 0 ) newData.user = Object.assign({}, state.user, {credits: action.credits})
			return objectAssign({}, state, newData)

		case 'REQUEST_USER_BOOKMARKS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {bookmarks: true})
			})

		case 'RECEIVE_USER_BOOKMARKS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {bookmarks: false}),
				bookmarks: action.bookmarks
			})

		case 'REQUEST_USER_INTERESTS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {interests: true})
			})

		case 'RECEIVE_USER_INTERESTS':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {interests: false}),
				interests: action.interests
			})

		case 'REQUEST_VIEW_HISTORY':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {history: true})
			})

		case 'RECEIVE_VIEW_HISTORY':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {history: false}),
				history: action.history
			})

		case 'RECEIVE_NEW_VIEW_HISTORY':
			var currentHistory = state.history,
				newPost = action.history;
			for (var i = currentHistory.length - 1; i >= 0; i--) {
				if( currentHistory[i].ID == newPost.ID ) {
					currentHistory.splice(i, 1);
					break
				}
			}
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {history: false}),
				history: [newPost].concat( currentHistory )
			})

		case 'REQUEST_PASSWORD_RESET_LINK':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {passwordReset: true})
			})

		case 'RECEIVE_PASSWORD_RESET_LINK':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {passwordReset: false})
			})

		case 'REQUEST_PASSWORD_RESET':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {passwordReset: true})
			})

		case 'RECEIVE_PASSWORD_RESET':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {passwordReset: false}),
				passwordReset: action.success
			})

		case 'RECEIVE_EMAIL_VERIFICATION':
			return objectAssign({}, state, {
				user: Object.assign({}, state.user, {verified_email: true}),
			})

		case 'REQUEST_SUBSCRIPTION':
			return Object.assign({}, state, {
				fetching: Object.assign({}, state.fetching, {subscription: true})
			})

		case 'RECEIVE_SUBSCRIPTION':
			return Object.assign({}, state, {
				subscription: action.subscription,
				fetching: Object.assign({}, state.fetching, {subscription: false})
			})

		default:
			return state;

	}

}



// WEBPACK FOOTER //
// ./src/js/reducers/session.js